(function () {
  'use strict';

  // ─── POPUP ──────────────────────────────────────────────────────────────────
  const overlay = document.getElementById('preorder-popup-overlay');
  if (overlay) {
    function dismissPopup() {
      overlay.style.opacity = '0';
      overlay.style.transition = 'opacity 0.2s ease';
      setTimeout(() => overlay.remove(), 200);
    }
    const dismissBtn = document.getElementById('preorder-popup-dismiss');
    if (dismissBtn) dismissBtn.addEventListener('click', dismissPopup);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) dismissPopup(); });
  }

  // ─── COUNTDOWN ──────────────────────────────────────────────────────────────
  const banner = document.querySelector('.preorder-banner');
  if (banner) {
    const dateStr  = banner.dataset.dropDate;       // YYYY-MM-DD
    const mode     = banner.dataset.mode || 'preorder';
    const dropDate = new Date(dateStr + 'T23:59:59');

    const elDays  = document.getElementById('po-days');
    const elHours = document.getElementById('po-hours');
    const elMins  = document.getElementById('po-mins');
    const elSecs  = document.getElementById('po-secs');

    const pad = (n) => String(n).padStart(2, '0');

    function tick() {
      const diff = dropDate - new Date();

      if (diff <= 0) {
        // Drop date passed — clean up everything
        clearInterval(timer);
        banner.remove();
        resetButton();
        removeCartAttributes();
        return;
      }

      const days  = Math.floor(diff / 864e5);
      const hours = Math.floor((diff % 864e5) / 36e5);
      const mins  = Math.floor((diff % 36e5) / 6e4);
      const secs  = Math.floor((diff % 6e4) / 1e3);

      if (elDays)  elDays.textContent  = pad(days);
      if (elHours) elHours.textContent = pad(hours);
      if (elMins)  elMins.textContent  = pad(mins);
      if (elSecs)  elSecs.textContent  = pad(secs);
    }

    tick();
    const timer = setInterval(tick, 1000);

    // ─── BUTTON SWAP ──────────────────────────────────────────────────────────
    function swapButton() {
      const btn = document.querySelector('.product-page__add-to-cart');
      if (!btn) return;
      btn.dataset.originalText = btn.textContent.trim();
      btn.textContent = mode === 'restock'
        ? 'Reserve for Restock'
        : 'Pre-Order Now — Reserve My Size';
    }

    function resetButton() {
      const btn = document.querySelector('.product-page__add-to-cart');
      if (btn && btn.dataset.originalText) {
        btn.textContent = btn.dataset.originalText;
      }
    }

    function removeCartAttributes() {
      document.querySelectorAll('input[name^="attributes[Pre-Order"]')
        .forEach((el) => el.remove());
    }

    // Run after variant controller has settled
    setTimeout(swapButton, 400);

    // ─── CART ATTRIBUTE INJECTION (PageFly compatible) ──────────────────────
    // Intercept fetch calls to /cart/add.js and inject pre-order attributes
    // so orders are tagged in Shopify admin regardless of page builder used
    const productTitle = document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : '';
    const poAttrs = {
      'Pre-Order': 'Yes',
      'Pre-Order Product': productTitle,
      'Pre-Order Date': dateStr
    };

    const _origFetch = window.fetch;
    window.fetch = function(resource, options) {
      const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (url.includes('/cart/add')) {
        try {
          const body = options && options.body;
          if (body) {
            if (typeof body === 'string') {
              // JSON body — parse, inject, re-stringify
              let data = JSON.parse(body);
              if (data) {
                if (!data.properties) data.properties = {};
                Object.assign(data.properties, poAttrs);
                options = Object.assign({}, options, { body: JSON.stringify(data) });
              }
            } else if (body instanceof FormData) {
              // FormData body — append directly (safe, no serialization)
              Object.entries(poAttrs).forEach(function(entry) {
                body.append('properties[' + entry[0] + ']', entry[1]);
              });
            }
          }
        } catch (e) { /* leave as-is */ }
      }
      return _origFetch.call(this, resource, options);
    };
  }

})();
